export default {
  app: {
    privacy: {
      policy: 'سياسة الخصوصية',
      expansive: 'باستخدام Expansive، فإنك توافق على {action} Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'انتهت الجلسة',
    sessionExpiredDescription: 'انتهت جلستك. يرجى تسجيل الدخول مرة أخرى لمتابعة استخدام التطبيق.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'اختر اللغة',
      chooseLanguageDescription:
        'اختر لغتك المفضلة للتطبيق. سيؤدي ذلك إلى تغيير لغة الواجهة والمحتوى.',
    },
    userSelection: {
      cancel: 'إلغاء',
      createNewUser: 'اسمه غير مدرج',
      newUser: 'مستخدم جديد',
      selectAnExistingUser: 'اختر مستخدمًا موجودًا',
      selectUserHint: 'اختر مستخدمًا موجودًا أو أنشئ مستخدمًا جديدًا للمتابعة.',
      startTypingToSearch: 'ابدأ الكتابة...',
    },
    verification: {
      codeVerification: {
        continue: 'متابعة',
        header: 'أدخل رمز الوصول إلى الموقع',
        invalidCode: 'رمز غير صالح، يرجى المحاولة مرة أخرى.',
      },
      geoVerification: {
        continueWithoutVerifying: 'المتابعة بدون التحقق من الموقع',
        enterSiteAccessCode: 'أدخل رمز الوصول إلى الموقع',
        locationNotEnabledOrAvailable: 'لماذا أرى هذا؟',
        notAvailable: {
          description: 'موقع GPS غير مدعوم على هذا الجهاز.',
          header: 'الموقع غير مدعوم',
        },
        notEnabled: {
          description: 'خدمات الموقع غير مفعلة أو لم يتم منح الإذن.',
          header: 'الموقع غير مفعل',
        },
        notVerified: {
          description: 'تشير بيانات GPS إلى أنك لست في الموقع.',
          header: 'لم يتم التحقق من الموقع',
        },
        tryAgain: 'حاول مرة أخرى',
        unavailable: {
          description: 'تعذر علينا التحقق من موقع GPS الخاص بك.',
          header: 'الموقع غير متوفر',
        },
        unknown: {
          description: 'غير قادرين على تحديد موقعك.',
          header: 'الموقع غير معروف',
        },
        verified: {
          description: 'تشير بيانات GPS إلى أنك في الموقع.',
          header: 'تم التحقق من الموقع',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'لم يتم العثور على أصول',
        emptyDescription: 'لا توجد أصول مرتبطة بأمر العمل هذا.',
        warrantyParts: 'تنتهي ضمان القطع',
        serialNumber: 'الرقم التسلسلي',
        none: '<لا يوجد>',
      },
      updates: {
        emptyTitle: 'لم يتم العثور على تحديثات',
        emptyDescription: 'لا توجد تحديثات لهذا أمر العمل.',
        unknownUser: 'مستخدم غير معروف',
        none: 'لا يوجد',
        addComment: {
          buttonLabel: 'إضافة تعليق',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'المخاطر',
          no: 'لا',
          yes: 'نعم',
        },
      },
    },
    attachmentsList: {
      attachments: 'المرفقات',
      documents: 'المستندات',
      siteDocuments: 'مستندات الموقع',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'المخاطر',
        induction: 'التعريف',
        safeToProceed: 'آمن للمتابعة',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'تاريخ الاستحقاق',
        activeSessions: 'الجلسات النشطة',
        activeSessionsDescription:
          'أنت مسجل بالفعل في أوامر العمل التالية. يجب عليك تسجيل الخروج من هذه الأوامر قبل تسجيل الدخول إلى أمر عمل جديد.',
        resumeSession: 'استئناف',
        startTime: 'بدأ في',
        unexpectedErrorTitle: 'خطأ غير متوقع',
        unexpectedErrorMessage:
          'حدث خطأ غير متوقع أثناء محاولة إنشاء الجلسات الخاصة بك. يرجى المحاولة مرة أخرى لاحقًا.',
        engineerNotFound: 'المهندس غير موجود',
        engineerNotFoundDescription:
          'المهندس الذي تحاول تسجيل دخوله غير موجود في النظام. يرجى التواصل مع المسؤول.',
      },
      verification: {
        code: {
          description:
            'للتسجيل، يرجى الحصول على الرمز المكون من 4 أرقام من مدير الموقع أو جهة الاتصال المعينة.',
        },
        geo: {
          continue: 'متابعة',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'يرجى الحصول على رمز الوصول من مدير الموقع أو جهة الاتصال المعينة لإكمال زيارتك.',
            checkOut: 'تسجيل الخروج',
            completeBeforeLeaving: 'يرجى إكمال النموذج التالي قبل المغادرة.',
            continue: 'متابعة',
            noResolutionSelected: 'يرجى اختيار حل قبل المتابعة.',
            quoteRequired: {
              hint: 'تمت الزيارة، سيتم تقديم عرض سعر لاحقًا',
              label: 'مطلوب عرض سعر',
            },
            returnVisitRequired: {
              hint: 'سنعود مرة أخرى لإكمال العمل',
              label: 'مطلوب زيارة عودة',
            },
            serviceCompleted: {
              hint: 'لا يلزم اتخاذ إجراء إضافي',
              label: 'تم إكمال الخدمة',
            },
            uploadCheckout: 'تحميل ملف أو صورة أو فيديو',
            visitNotes: 'ملاحظات الزيارة',
            workOrderResolution: 'حل أمر العمل',
            enterNotes: 'أدخل أي ملاحظات هنا...',
            errors: {
              timedOut: 'انتهت المهلة، تجاوزت 30 ثانية. يرجى المحاولة مرة أخرى',
              closingSession: 'خطأ في إغلاق الجلسة',
            },
          },
          success: {
            description:
              'شكرًا لزيارتك {site}. | لا يزال لدى {site} أمر عمل مفتوح واحد. | لا يزال لدى {site} {count} أمر عمل مفتوح.',
            endVisit: 'إنهاء الزيارة',
            header: 'تم تسجيل الخروج بنجاح',
            viewWorkOrders: 'تسجيل الدخول إلى أمر عمل آخر',
          },
          verification: {
            code: {
              description:
                'للتسجيل الخروج، يرجى الحصول على الرمز المكون من 4 أرقام من مدير الموقع أو جهة الاتصال المعينة.',
              continue: 'متابعة',
            },
            geo: {
              checkOut: 'تسجيل الخروج',
              continue: 'متابعة',
            },
          },
        },
        detail: {
          assets: 'الأصول',
          call: 'اتصال',
          checkOut: 'تسجيل الخروج',
          closed: 'مغلق',
          details: 'التفاصيل',
          dueBy: 'تاريخ الاستحقاق',
          manageEngineers: 'إدارة المهندسين',
          notAvailable: 'غير متوفر',
          pointOfContact: 'جهة الاتصال',
          siteAccessTimes: 'أوقات الوصول إلى الموقع',
          siteAccessInstructions: 'تعليمات الوصول',
          siteAddress: 'عنوان الموقع',
          siteNotes: 'ملاحظات الموقع',
          siteTelephone: 'هاتف الموقع',
          siteLocation: 'الموقع',
          updates: 'التحديثات',
          more: 'المزيد',
          mismatchErrorTitle: 'خطأ في أمر العمل',
          mismatchErrorMessage:
            'أمر العمل الذي تحاول الوصول إليه لا يتطابق مع الأمر الذي سجلت الدخول إليه حاليًا. يرجى التحقق من أمر العمل والمحاولة مرة أخرى.',
          siteDocuments: 'مستندات الموقع',
          validFrom: 'صالح من',
          validUntil: 'صالح حتى',
          documentName: 'اسم المستند',
          documentType: 'نوع المستند',
          attachments: 'ملفات أمر العمل',
          download: 'تنزيل',
          workDetails: 'تفاصيل العمل',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'إضافة مهندس مساعد',
            assistantEngineers: 'المهندسون المساعدون',
            description: 'لأسباب أمنية، يرجى تحديد أسماء كل مهندس في الموقع.',
            editMainEngineer: 'تعديل المهندس الرئيسي',
            errors: {
              creatingEngineer: 'خطأ في إنشاء المهندس',
              creatingSession: 'خطأ في إنشاء الجلسة',
            },
            header: 'المهندسون في الموقع',
            mainEngineer: 'المهندس الرئيسي',
            newAssistantEngineer: 'أدخل اسمه الكامل',
            next: 'التالي',
            removeEngineer: 'إزالة المهندس',
            selectExistingAssistantEngineer: 'ابدأ بكتابة اسمه',
          },
          index: {
            description: 'لأسباب أمنية، يرجى تحديد أسماء كل مهندس في الموقع.',
            errorCreatingEngineer: 'حدث خطأ أثناء إنشاء المهندس، يرجى المحاولة مرة أخرى.',
            header: 'المهندسون في الموقع',
            hintMainEngineer: 'أدخل الاسم الكامل للمهندس الرئيسي',
            newMainEngineer: 'مهندس رئيسي جديد',
            next: 'التالي',
            selectExistingMainEngineer: 'اختر مهندسًا رئيسيًا موجودًا',
            yes: 'نعم',
            no: 'لا',
            mainEngineerLabel: 'هل أنت المهندس الرئيسي؟',
          },
        },
        index: {
          callUsOn: 'اتصل بنا على {phoneNumber}',
          description: 'لا يمكنك العثور على ما تبحث عنه؟',
          dueBy: 'تاريخ الاستحقاق',
          header: 'اختر أمر العمل',
          notAvailable: 'غير متوفر',
          searchWorkOrders: 'ابحث في أوامر العمل...',
        },
        manageEngineers: {
          manageEngineers: 'إدارة المهندسين',
          notWorking: 'العمال غير النشطين',
          pause: 'إيقاف مؤقت',
          resume: 'استئناف',
          workingNow: 'العمال النشطون',
          startTime: 'وقت البدء',
          endTime: 'وقت الانتهاء',
          duration: 'المدة',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'ملاحظات',
            feedbackDescription: 'يرجى تقديم ملاحظات حول أمر العمل لمساعدتنا في تحسين خدماتنا.',
            feedbackLabel: 'ملاحظات',
            filesLabel: 'المرفقات',
            submissionLabel: 'إرسال الملاحظات',
          },
          hazards: {
            back: 'رجوع',
            hazards: 'المخاطر',
            next: 'التالي',
            no: 'لا',
            noTasksForHazard: 'لا توجد مهام لإكمالها لهذا الخطر.',
            yes: 'نعم',
          },
          induction: {
            continue: 'متابعة',
            induction: 'التعريف',
          },
          index: {
            checkIn: 'تسجيل الدخول',
            description: 'يرجى إكمال تقييم المخاطر التالي للعمل المحدد.',
            fail: 'فشل في معالجة فحوصات بدء أمر العمل.',
            haltMessage:
              'تم اكتشاف مخاطر محتملة. يرجى إيقاف العمل، ومراجعة إرشادات السلامة، والتواصل مع المشرف لمزيد من التعليمات.',
            header: 'فحوصات بدء العمل',
            endVisit: 'إنهاء الزيارة',
            leaveFeedback: 'اترك ملاحظات',
          },
          safeToProceed: {
            continue: 'متابعة',
            safeToProceed: 'آمن للمتابعة',
          },
        },
      },
    },
    index: {
      title: 'مرحبًا',
      description: 'امسح رمز QR في موقعك للبدء.',
    },
    login: {
      errorTitle: 'خطأ غير متوقع',
      errorMessage: 'حدث خطأ غير متوقع. يرجى محاولة مسح رمز QR مرة أخرى.',
    },
    unauthenticated: {
      welcome: {
        title: 'مرحبًا بك في {site}',
        description:
          'قبل أن نتمكن من عرض أي أوامر عمل، نحتاج إلى التحقق من بياناتك. انقر على الزر أدناه للمتابعة.',
        next: 'متابعة',
      },
      index: {
        errorTitle: 'خطأ غير متوقع',
        errorMessage: 'حدث خطأ غير متوقع. يرجى محاولة مسح رمز QR مرة أخرى.',
      },
      contractor: {
        title: 'لمن تعمل؟',
        contractor: 'المقاول',
        contractorLabel: 'ابدأ بكتابة اسم شركتك',
        contractorHint: 'يجب إدخال 3 أحرف أو أكثر لرؤية النتائج',
        defaultSelectPlaceholder: '--يرجى الاختيار--',
        next: 'التالي',
      },
      user: {
        title: 'من أنت؟',
        cancel: 'إلغاء',
        createNewUserLabel: 'اسمي غير مدرج',
        existingUserLabel: 'ابدأ بكتابة اسمك',
        existingUserHint: 'يجب إدخال 3 أحرف أو أكثر لرؤية النتائج',
        newUserLabel: 'أدخل اسمك الكامل',
        next: 'التالي',
        user: 'مستخدم',
      },
      verification: {
        methods: {
          add: {
            add: 'إضافة طريقة تحقق',
            defaultSelectPlaceholder: '--يرجى الاختيار--',
            emailLabel: 'البريد الإلكتروني',
            existingMethodWarning:
              'لديك بالفعل طلب معلق لطريقة التحقق هذه في انتظار موافقة المسؤول. إضافة طريقة جديدة ستلغي الطلب الحالي.',
            method: 'الطريقة',
            methodLabel: 'الطريقة',
            mobileCountryHint: 'يرجى اختيار رمز الدولة',
            mobileCountryLabel: 'رمز الدولة للجوال',
            mobileHint: 'يرجى إدخال رقم جوالك',
            mobileLabel: 'الجوال',
            title: 'إضافة طريقة تحقق',
          },
          confirm: {
            confirm: 'تأكيد',
            description: 'يرجى تأكيد طريقة التحقق للمتابعة.',
            label: 'أدخل الرمز الخاص بك',
            resend: 'إعادة الإرسال',
            resendPrompt: 'لم تستلم رمزًا؟',
            title: 'تأكيد طريقة التحقق',
          },
          confirmed: {
            description:
              'سيتم إعلامك بمجرد الموافقة على طريقة التحقق هذه من قبل المسؤول، ويمكنك بعد ذلك استخدامها للتحقق من هويتك.',
            forceApproval: 'حتى تتم الموافقة عليها، لا يمكنك الوصول إلى أوامر العمل.',
            nonForceApproval:
              'في هذه الأثناء، يمكنك الاستمرار في الوصول إلى أوامر العمل بوصول محدود.',
            nonForceApprovalButtonLabel: 'المتابعة بوصول محدود',
            title: 'بانتظار الموافقة',
          },
          addNew: 'إضافة طريقة تحقق جديدة',
          description: 'نحتاج إلى التحقق من هويتك لمنحك وصولاً كاملاً إلى أمر العمل.',
          email: 'البريد الإلكتروني',
          hint: 'سنرسل رابطًا إلى طريقة التحقق المحددة يمنحك وصولاً كاملاً إلى أمر العمل. إذا كنت بحاجة إلى تغيير أي من طرق التحقق الحالية، يرجى التواصل مع المسؤول.',
          label: 'اختر طريقة تحقق',
          next: 'التالي',
          pendingHint: 'بانتظار موافقة المسؤول',
          sms: 'رسالة نصية',
          title: 'التحقق',
        },
        optional: {
          hint: 'التحقق من بيانات المستخدم يمنحك وصولاً كاملاً إلى أمر العمل',
          label: 'هل ترغب في التحقق من بيانات المستخدم؟',
          next: 'التالي',
          no: 'لا',
          noHint:
            'لا أرغب في التحقق من بيانات المستخدم وأرغب في المتابعة بوصول محدود إلى أمر العمل',
          title: 'التحقق',
          yes: 'نعم',
          yesHint: 'أرغب في التحقق من بيانات المستخدم والحصول على وصول كامل إلى أمر العمل',
        },
        sent: {
          description:
            'تم إرسال رابط تسجيل الدخول إلى {identifier}. يرجى النقر على الرابط لإكمال تسجيل الدخول.',
          title: 'تم إرسال رابط تسجيل الدخول',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'أمس',
      today: 'اليوم',
      days: {
        monday: 'الاثنين',
        tuesday: 'الثلاثاء',
        wednesday: 'الأربعاء',
        thursday: 'الخميس',
        friday: 'الجمعة',
        saturday: 'السبت',
        sunday: 'الأحد',
      },
      months: {
        january: 'يناير',
        february: 'فبراير',
        march: 'مارس',
        april: 'أبريل',
        may: 'مايو',
        june: 'يونيو',
        july: 'يوليو',
        august: 'أغسطس',
        september: 'سبتمبر',
        october: 'أكتوبر',
        november: 'نوفمبر',
        december: 'ديسمبر',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'حدث خطأ',
      message: 'يرجى محاولة مسح رمز QR مرة أخرى.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'مستخدم غير معروف',
      },
      none: 'لا يوجد',
      types: {
        stateTransition: 'تم تغيير الحالة',
        contractorAssigned: 'تم تعيين المقاول',
        engineerAssigned: 'تم تعيين المهندس',
        serviceAssigned: 'تم تعيين الخدمة',
        priorityChanged: 'تم تغيير الأولوية',
        actionableDateChanged: 'تم تغيير تاريخ التنفيذ',
        dueDateChanged: 'تم تغيير تاريخ الاستحقاق',
        etaDateChanged: 'تم تغيير تاريخ الوصول المتوقع',
        spendLimitApproved: 'تمت الموافقة على حد الإنفاق',
        spendLimitCancelled: 'تم إلغاء طلب حد الإنفاق',
        spendLimitRejected: 'تم رفض حد الإنفاق',
        spendLimitRequested: 'تم طلب حد الإنفاق',
        jobSheetUploaded: 'تم تحميل ورقة العمل',
        slaAlertSent: 'تم إرسال تنبيه تجاوز SLA',
        issuedWorkPermit: 'تم إصدار تصريح العمل',
        requestForServiceSent: 'تم إرسال طلب خدمة',
        comment: 'تمت إضافة تعليق',
        unknown: 'حدث غير معروف',
      },
      labels: {
        actionableDate: 'تاريخ التنفيذ',
        comment: 'تعليق',
        file: 'ملف',
        contractor: 'مقاول',
        dueDate: 'تاريخ الاستحقاق',
        etaDate: 'تاريخ الوصول المتوقع',
        engineer: 'مهندس',
        priority: 'الأولوية',
        requestForService: 'طلب خدمة',
        service: 'خدمة',
        spendLimit: 'حد الإنفاق',
        status: 'الحالة',
        workPermit: 'تصريح العمل',
      },
    },
  },
}
